<template>
	<div class="hiq-public-art">
		<search v-if="showSearch"/>
		<search-info v-if="showSearch && query"/>
		<art-list />
		<load-more v-if="canLoadMore"/>
	</div>
</template>

<script>
import Search from './components/Search.vue';
import SearchInfo from './components/SearchInfo.vue';
import ArtList from './components/ArtList.vue';
import LoadMore from './components/LoadMore.vue';
export default {
	name: 'app',
	computed: {
		showSearch(){
			return this.$store.state.showSearch;
		},
		query() {
			return this.$store.state.art.query;
		},
		canLoadMore() {
			return this.$store.state.art.canLoadMore;
		}
	},
	components: {
		Search,
		SearchInfo,
		ArtList,
		LoadMore,
		SearchInfo
	}
}
</script>
